import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface RequestOTPInterface {
  name: string;
  mobile: string;
}

export const useRequestOTP = () => {
  const mutate = useMutation(({ name, mobile }: RequestOTPInterface) => {
    return postAPI('/creator-api/request_otp', {
      username: name,
      mobile,
    });
  });

  return mutate;
};

export default useRequestOTP;
